<template>

<div id="c-floating" class="c-floating">
    <Transition name="c-floating-btns">
    <ul v-show="isShow">
        <li>
            <a class="c-btn c-btn--special-f c-btn--shadow" href="#" @click.prevent="anchor('special')">物件一覧</a>
        </li>
        <li>
            <a class="c-btn c-btn--contact-f c-btn--shadow" href="#" @click.prevent="anchor('campaign')">今すぐ無料相談</a>
            <Transition name="c-floating-balloon">
            <picture v-show="isShow">
                <source media="(max-width: 800px)" srcset="/specialoffer/assets/img/common/balloon-campaign-sp.png">
                <img class="c-floating__balloon" src="/specialoffer/assets/img/common/balloon-campaign-pc.png" alt="キャンペーン実施中" width="201" height="55">
            </picture>
            </Transition>
        </li>
    </ul>
    </Transition>
</div>
</template>

<script>

import { gsap, Quart } from 'gsap/all';
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

export default {
    data() {
        return {}
    },
    computed: {
        isShow() {
            return this.$store.getters.showFloating;
        }
    },
    mounted() {},
    methods: {
        anchor(id) {
            gsap.to(window, { duration: 0.8, scrollTo: { y: `#${id}`, autoKill: false }, ease: Quart.easeInOut});
        }
    }
}

</script>